import { render, staticRenderFns } from "./transitionpage.vue?vue&type=template&id=4a70a440&scoped=true"
import script from "./transitionpage.vue?vue&type=script&lang=js"
export * from "./transitionpage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a70a440",
  null
  
)

export default component.exports